/**
 * Request durable (persistent) storage from the browser.
 *
 * Ordelio is offline-first: shopping data lives in IndexedDB and the app shell
 * in the service worker cache. Without persistence the browser may evict this
 * data under disk pressure. Chrome grants persistence silently for installed
 * PWAs and the Android (TWA) app; other browsers may ignore the request.
 * Failure is harmless, so this is fire-and-forget.
 */
export function requestPersistentStorage(): void {
  if (!navigator.storage?.persist) return

  navigator.storage
    .persisted()
    .then((alreadyPersisted) => {
      if (alreadyPersisted) return true
      return navigator.storage.persist()
    })
    .then((persisted) => {
      if (!persisted) {
        console.info('[storage] persistent storage not granted; local data may be evicted under disk pressure')
      }
    })
    .catch((e) => console.warn('[storage] persistent storage request failed:', e))
}
